import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { fetchAgencyTypesList } from '@libs/api/agencyTypes';
import { AgencyTypeListItem } from '@libs/models/agencies';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  agencyTypes: AgencyTypeListItem[];
  page: number;
  perPage: number;
  total: number;
  load: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
};

export const useAgencyTypesListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  agencyTypes: [],
  page: 1,
  perPage: 50,
  total: 0,

  load: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchAgencyTypesList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        agencyTypes: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
}));
